import React, { FunctionComponent } from 'react';

import './Page.scss';

export const Page: FunctionComponent<{}> = (props) => (
    <div className="page">
        {props.children}
    </div>
);